module.exports = __webpack_public_path__ + "static/img/devices.aacd87b1.png";